import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

function parseQuery(search: string): Record<string, string> {
  const params = new URLSearchParams(search);
  const result: Record<string, string> = {};
  params.forEach((value, key) => {
    if (value) {
      result[key] = value;
    }
  });
  return result;
}

export function useQueryParams<T extends Record<string, string | undefined> = Record<string, string>>(
  defaultValues?: T,
) {
  const location = useLocation();

  return useMemo(() => {
    const parsed = parseQuery(location.search);
    return {
      ...defaultValues,
      ...parsed,
    } as T;
  }, [location.search, defaultValues]);
}
